<template>
	<div id="app" class="d-flex flex-column align-items-center">
		<div id="app-debug" class="row app-row">
			<div class="offset-1 col-10 offset-md-2 col-md-8 p-0">
				<div class="form-group m-0" v-if="this.appConfig.debug">
					<select id="step-select" class="form-control debug-component" v-model="currentStep" v-on:change="goToStep($event.target.value)">
						<option v-for="step in steps" v-bind:key="step">{{ step }}</option>
					</select>
				</div>
				<div class="form-group form-inline m-0" v-if="this.appConfig.debug">
					<div class="debug-component">
						<button class="btn header-btn" v-on:click="goToStep(steps[0])">Restart</button>
					</div>
					<div class="debug-component">
						<button class="btn header-btn" v-on:click="clearSavedLead">Clear Lead</button>
					</div>
					<div class="debug-component">
						<button class="btn header-btn" v-on:click="logLead">Log lead</button>
					</div>
					<div class="debug-component">
						<button class="btn header-btn" v-on:click="logApiLead">Log API lead</button>
					</div>
					<div class="debug-component">
						<button class="btn header-btn" v-on:click="logMediaAlphaLead">Log MA lead</button>
					</div>
					<div class="debug-component">
						<button class="btn header-btn" v-on:click="saveLead">Save lead</button>
					</div>
				</div>
			</div>
		</div>
		<h5 id="app-title" v-if="this.appConfig.title">{{ this.appConfig.title }}</h5>
		<div id="app-buttons" class="row app-row">
			<div class="offset-1 col-5 offset-md-2 col-md-4 d-flex p-0">
				<div id="back" v-bind:class="{ 'visibility-hidden': currentStepIndex <= 0 || submittedLead || loading }">
					<button class="btn header-btn" v-on:click="goToPreviousStep">Back</button>
				</div>
			</div>
			<div class="col-5 col-md-4 d-flex justify-content-end p-0">
				<div id="call-us-header" v-bind:class="{ 'visibility-hidden': !this.appConfig.callUsPhoneNumber}">
					<a class="btn header-btn" v-bind:href="'tel:' + this.appConfig.callUsPhoneNumber">Call Us</a>
				</div>
			</div>
		</div>
		<div id="app-progress" class="row app-row justify-content-center">
			<div id="progress" class="progress col-10 col-md-8 align-self-center">
				<div class="progress-bar" role="progressbar" v-bind:style="'width: ' + percentageComplete + '%'" v-bind:aria-valuenow="percentageComplete" aria-valuemin="0" aria-valuemax="100">
				</div>
			</div>
		</div>
		<div id="app-step" ref="appStep" class="row app-row step-row justify-content-center" v-on:scroll="updateScrollableAndScrolledToEnd">
			<div class="col-12 align-self-top p-0">
				<input id="leadid_token" ref="jornayaId" name="universal_leadid" type="hidden" value=""/>
				<input id="trustedform_id" ref="trustedformId" name="trustedform_id" type="hidden" value = ""/>
				<input id="trustedform_url" ref="trustedformUrl" name="trustedform_url" type="hidden" value = ""/>
				<step v-bind:lead="lead" v-bind:eventBus="eventBus" v-on:loading="onLoading" v-on:complete="saveLead" v-on:stepComplete="onStepComplete" v-on:preStepTransition="onPreStepTransition" v-on:postStepTransition="onPostStepTransition"></step>
			</div>
			<div id="app-step-scroll-indicator" ref="appStepScrollIndicator" class="col-12 align-self-top" v-bind:class="{ 'visibility-hidden': !scrollable || scrolledToEnd }">
				<div id="app-step-scroll-indicator-background">&#9660;</div>
			</div>
		</div>
	</div>
</template>

<script>

import { steps, stepValues } from "./steps.js"
import { v4 as uuidv4 } from "uuid"

import Vue from "vue"
import Step from "./Step.vue"

export default {
	name: "app",
	components: {
		Step
	},
	created: function() {
		// load vehicle year, make, model, trims
		var script = document.createElement("script");
		script.setAttribute("src", this.appConfig.avengeDigitalWidgetYearMakeModelTrimsScriptUrl);
		script.setAttribute("async", true);
		document.head.appendChild(script);

		this.checkForQueryParameters();

		// load lead from local storage
		this.loadLeadFromLocalStorage();

		// redirect to start step if we don't have lead info
		if (this.currentStep != stepValues.Name && this.lead.firstName == null) {
			this.$router.replace(stepValues.Name);
			this.utils.log("redirect to Name");
		}

		// prevent route changes while submitting lead
		this.$router.beforeEach((to, from, next) => {
			if (from && from.path === "/PhoneNumber" && this.submittingLead) {
				this.utils.log("preventing route change while submitting lead");
				next(false);
			}
			else if (this.loading) {
				this.utils.log("preventing route change while loading");
				next(false);
			}
			else {
				next();
			}
		});
	},
	mounted: function() {
		this.updateScrollableAndScrolledToEnd();
		window.addEventListener("resize", this.updateScrollableAndScrolledToEnd)
	},
	data: function() {
		return {
			steps: steps,
			lead: {
				id: uuidv4(),
				insuranceType: "Auto",
				isInsured: null,
				currentInsurer: null,
				insuranceLength: null,
				requestedCoverageType: null,
				numberOfDrivers: null,
				pendingVehicles: [],
				vehicles: [],
				licenseStatus: null,
				accidentsOrTicketsInPast3Years: null,
				dui: null,
				needsSr22: null,
				creditRating: null,
				isMarried: null,
				currentResidenceType: null,
				isInterestedInHomeOrRentersInsuranceQuotes: null,
				currentResidenceLengthInMonths: null,
				gender: null,
				dateOfBirthDay: "",
				dateOfBirthMonth: "",
				dateOfBirthYear: "",
				isInMilitary: null,
				streetAddress: null,
				city: null,
				state: "",
				zipCode: null,
				firstName: null,
				lastName: null,
				email: null,
				phoneNumber: null,
				submitted: false,
				submittedSuccessfully: false
			},
			eventBus: new Vue(),
			subId: null,
			startTime: new Date(),
			scrollable: false,
			scrolledToEnd: false,
			submittingLead: false,
			submittedLead: false,
			loading: false
		}
	},
	methods: {
		checkForQueryParameters: function() {
			var params = new URLSearchParams(window.location.search);

			// zip code
			var zipCode = params.get("zipCode");

			if (zipCode && zipCode.length == 5) {
				this.lead.zipCode = zipCode;
				this.utils.log("loaded zipCode " + zipCode);
			}

			// sub ids
			var subId = params.get("subId");

			if (subId) {
				this.subId = subId;
				this.utils.log("loaded sub id " + subId);
			}

			var subId2 = params.get("subId2");

			if (subId2) {
				this.subId2 = subId2;
				this.utils.log("loaded sub id 2 " + subId2);
			}

			var subId3 = params.get("subId3");

			if (subId3) {
				this.subId3 = subId3;
				this.utils.log("loaded sub id 3 " + subId3);
			}

			var subId4 = params.get("subId4");

			if (subId4) {
				this.subId4 = subId4;
				this.utils.log("loaded sub id 4 " + subId4);
			}

			var subId5 = params.get("subId5");

			if (subId5) {
				this.subId5 = subId5;
				this.utils.log("loaded sub id 5 " + subId5);
			}
		},
		updateScrollableAndScrolledToEnd: function () {
			var appStep = this.$refs.appStep;
			if (!appStep) {
				return;
			}

			this.scrollable = appStep.scrollHeight > appStep.clientHeight;
			this.scrolledToEnd = (appStep.scrollTop + appStep.clientHeight > appStep.scrollHeight - 20);
		},
		goToPreviousStep: function() {
            this.eventBus.$emit("goToPreviousStep");
        },
		goToStep: function(step) {
			this.eventBus.$emit("goToStep", step);
		},
		onStepComplete: function() {
			this.persistLeadToLocalStorage();
		},
		onPreStepTransition: function() {
			// reset scrollbar
			this.$refs.appStep.scrollTop = 0;
		},
		onPostStepTransition: function() {
			this.updateScrollableAndScrolledToEnd();
		},
		clearSavedLead: function() {
			localStorage.removeItem("lead-data");
			localStorage.removeItem("lead-last-update-time");
			this.utils.log("removed old lead from localStorage");
		},
		logLead: function() {
			this.utils.log(this.lead);
		},
		logApiLead: function() {
			var apiLead = this.getApiLead();
			this.utils.log(apiLead);
		},
		logMediaAlphaLead: function() {
			this.mediaAlphaUtils.getDataQueryStringParameterValue(this.startTime, this.lead, this.$refs.jornayaId, this.appConfig.tcpaText);
		},
		loadLeadFromLocalStorage: function() {
			if (typeof(Storage) !== "undefined") {
				try {
					// check expiration
					var leadLastUpdateTime = localStorage.getItem("lead-last-update-time");

					if (leadLastUpdateTime) {
						var currentTime = new Date().getTime();

						// within expiration time
						if (currentTime - leadLastUpdateTime < this.appConfig.localStorageExpirationInMilliseconds) {
							this.lead = JSON.parse(localStorage.getItem("lead-data"));
							this.lead.submitted = false;
							this.utils.log("loaded lead from localStorage");
						}
						else {
							localStorage.removeItem("lead-data");
							localStorage.removeItem("lead-last-update-time");
							this.utils.log("removed old lead from localStorage");
						}
					}
				} catch (e) {
					this.clearSavedLead();
					this.utils.log(e);
				}
			}
		},
		persistLeadToLocalStorage: function() {
			if (typeof(Storage) !== "undefined") {
				try {
					const json = JSON.stringify(this.lead);
					localStorage.setItem("lead-data", json);
					localStorage.setItem("lead-last-update-time", new Date().getTime());
					this.utils.log("persisted lead to localStorage");
				}
				catch (e) {
					this.utils.log("error persisting lead to localStorage");
					this.utils.log(e);
					this.clearSavedLead();
				}
			}
		},
		onLoading: function(loading) {
			this.utils.log("loading: " + loading)
			this.loading = loading;
		},
		saveLead: function(retryAttempt) {
			if (!this.submittingLead) {
				this.submittedLead = true;
				this.submittingLead = true;
				var apiLead = this.getApiLead();
				this.utils.log("saving lead");
				this.utils.log(apiLead);

				var vm = this;

				this.axios.post("/Api/Widget/SaveLead", apiLead)
					.then(function (response) {
						vm.utils.log("saved lead");
						vm.utils.log(response);
						vm.redirect(true, response.data);
					})
					.catch(function (error) {
						var errorMessage = "error saving lead";

						if (error.response) {
							errorMessage += " - status " + error.response.status;
						}
						else if (error.request) {
							errorMessage += " - no response (" + error.request.status + ")";
						}
						else {
							errorMessage += " - error " + error.message;
						}

						vm.utils.log(errorMessage);
						vm.utils.log(error);

						try {
							vm.$gtag.event(errorMessage, {"event_category": "App", "event_label": vm.lead.id});
						} catch (e) {
							vm.utils.log(e);
						}

						// retry save
						vm.utils.log("retry: " + retryAttempt);
						if (!retryAttempt) {
							vm.$gtag.event("retry saving lead", {"event_category": "App", "event_label": vm.lead.id});
							vm.submittingLead = false;
							vm.saveLead(true);
						}
						else {
							vm.redirect(false);
						}
					});
			}
			else {
				this.utils.log("lead is already being submitted");
			}
		},
		redirect: function(success, responseData) {
			if (success && responseData) {

				var url = "";

				if (responseData.Redirect && this.appConfig.redirectUrlBase) {

					if (responseData.Redirect.RedirectPage) {
						url = this.appConfig.redirectUrlBase + responseData.Redirect.RedirectPage;
					}
					else {
						url = this.appConfig.redirectUrlDefault;
					}

					switch (responseData.Redirect.ClickListingType) {
						case "MediaAlpha":
							url = url + "?id=" + this.lead.id;

							if (this.subId) {
								url = url + "&subId=" + this.subId;
							}

							if (this.subId2) {
								url = url + "&subId2=" + this.subId2;
							}

							if (this.subId3) {
								url = url + "&subId3=" + this.subId3;
							}

							var dataQueryStringParameter = this.mediaAlphaUtils.getDataQueryStringParameterValue(this.startTime, this.lead, this.$refs.jornayaId, this.appConfig.tcpaText);

							if (dataQueryStringParameter) {
								url = url + "&data=" + dataQueryStringParameter;
							}
							break;
						case "Transparently":
							url = url + "?id=" + this.lead.id + "&t=T";
							break;
						case "InsideResponse":
							url = url + "?id=" + this.lead.id + "&t=I";
							break;
					}
				}
				else {
					url = this.appConfig.redirectUrlDefault;
				}

				this.$gtag.event("redirect", {"event_category": "App", "event_label": this.lead.id, "value": url});
				this.utils.log("redirect url: " + url);

				this.submittingLead = false;
				this.lead.submitted = true;
				this.lead.submittedSuccessfully = true;

				if (!url) {
					return;
				}

				if (this.appConfig.debug) {
					if (confirm("Redirect to " + url)) {
						window.location.replace(url);
					}
				}
				else {
					window.location.replace(url);
				}
			}
			else {
				this.$gtag.event("redirect", {"event_category": "App", "event_label": this.lead.id, "value": url});
				this.utils.log("redirect url: " + url);

				this.submittingLead = false;
				this.lead.submitted = true;
				this.lead.submittedSuccessfully = false;

				if (this.appConfig.redirectUrlDefault) {
					window.location.replace(this.appConfig.redirectUrlDefault);
				}
			}
		},
		getApiLead: function() {
			return {
				ApiKey: this.appConfig.apiKey,
				LeadSource: {
					Id: this.lead.id,
					Source: this.appConfig.siteId,
					SubSource: this.subId ? this.subId : this.appConfig.subId,
					SubSource2: this.subId2,
					SubSource3: this.subId3,
					SubSource4: this.subId4,
					SubSource5: this.subId5,
					LeadCampaignId: this.appConfig.leadCampaignId,
					TcpaText: this.appConfig.tcpaText,
					Url: document.location.protocol + "//" + document.location.hostname + document.location.pathname,
					JornayaId: this.$refs.jornayaId ? this.$refs.jornayaId.value : null,
					TrustedFormCertificateUrl: this.$refs.trustedformUrl && this.$refs.trustedformUrl.value ? this.$refs.trustedformUrl.value :
						this.$refs.trustedformId && this.$refs.trustedformId.value ? "https://cert.trustedform.com/" + this.$refs.trustedformId.value : null
				},
				InsuranceType: this.getInsuranceType(),
				IsInsured: this.lead.isInsured,
				CurrentInsurer: this.lead.currentInsurer,
				InsuranceLength: this.lead.insuranceLength ? this.lead.insuranceLength : "LessThanSixMonths",
				RequestedCoverageType: this.lead.requestedCoverageType,
				NumberOfDrivers: this.lead.numberOfDrivers,
				Vehicles: this.lead.vehicles,
				LicenseStatus: this.lead.licenseStatus,
				AccidentsOrTicketsInPast3Years: this.lead.accidentsOrTicketsInPast3Years,
				Dui: this.lead.dui,
				NeedsSr22: this.lead.needsSr22,
				CreditRating: this.lead.creditRating,
				IsMarried: this.lead.isMarried,
				CurrentResidenceType: this.lead.currentResidenceType,
				IsInterestedInHomeOrRentersInsuranceQuotes: this.lead.isInterestedInHomeOrRentersInsuranceQuotes,
				CurrentResidenceLengthInMonths: this.lead.currentResidenceLengthInMonths,
				Gender: this.lead.gender,
				DateOfBirth: this.getDateOfBirth(),
				IsInMilitary: this.lead.isInMilitary,
				StreetAddress: this.lead.streetAddress,
				City: this.lead.city,
				State: this.lead.state,
				ZipCode: this.lead.zipCode,
				FirstName: this.lead.firstName,
				LastName: this.lead.lastName,
				Email: this.lead.email,
				PhoneNumber: this.lead.phoneNumber
			}
		},
		getInsuranceType: function() {
			switch (this.lead.insuranceType) {
				case "Auto":
					return "AutoInsurance";
				case "Home":
					return "HomeInsurance";
				default:
					return "AutoInsurance";
			}
		},
		getDateOfBirth: function() {
			return this.lead.dateOfBirthYear + "-" + this.lead.dateOfBirthMonth + "-" + this.lead.dateOfBirthDay;
		}
	},
	computed: {
		currentStep: {
			get: function () {
				return this.$route.path.replace("/", "");
			},
			set: function () {
				// ignore
			}
		},
		currentStepIndex: function() {
			return steps.indexOf(this.currentStep);
		},
		percentageComplete: function () {
			return 100.0 * this.currentStepIndex / (steps.length - 1);
		}
	}
}
</script>

<style>
#app {
	background-color: transparent;
}

#app-debug {
	flex: 0 0 auto;
}

#app-title {
	flex: 0 0 auto;
}

#app-buttons {
	flex: 0 0 auto;
}

#app-progress {
	flex: 0 0 auto;
}

#app-step {
	flex: 1 1 auto;
	overflow-y: overlay;
	overflow-x: hidden;
	width: 66.6666% !important;
	/*min-height: 200px !important;*/
}

#app-step-scroll-indicator {
	position: absolute;
	bottom: 0;
	width: 66.6666% !important;
	color: white;
	font-size: 20px;
	pointer-events: none;
	margin: 0 !important;
	padding-left: 20px;
	padding-right: 20px;
}

#app-step-scroll-indicator-background {
	background: linear-gradient(to top, rgba(21, 110, 211, 1), rgba(21, 110, 211, 0));
	height: 100%;
	width: 100%;
	text-align: center;
}

/* mobile */
@media only screen and (max-width: 767.98px) {
	/* this isn't working for some reason */
	/*.et_pb_row {
		padding: 0 !important;
	}*/

	#app-step, #app-step-scroll-indicator {
		width: 83.3333% !important;
	}
}

/* mobile and tablet */
@media only screen and (max-width: 991.98px) {
	#app-step {
		overflow-y: scroll;
		-webkit-overflow-scrolling: touch;
		height: 100%;
	}
}

#progress {
	width: 100%;
	padding: 0;
}

.step-title {
	color: white !important;
	text-align: center;
	margin-left: .25rem !important;
	margin-right: .25rem !important;
	margin-top: .5rem !important;
	margin-botton: .5rem !important;
}

.step-content {
	width: 100%;
	padding-left: .25rem !important;
	padding-right: .25rem !important;
	padding-top: .5rem !important;
	padding-botton: .5rem !important;
}

.visibility-hidden {
	visibility: hidden;
}

.select-max-width {
	max-width: 175px;
	margin: .5rem!important;
}

.debug-component {
	margin: .25rem !important;
}

.app-row {
	max-width: 1200px;
	margin: .25rem !important;
	width: 100% !important;
}

.step-row {
	flex: auto;
	width: 100% !important;
}

.progress {
	margin-bottom: 0;
}

.progress-bar {
	background-color: #73baff !important;
}

/* force min-width */
.step-items-wrapper {
	width: min-content;
}

.step-item {
	padding: .25rem !important;
	/* TODO smaller padding on mobile? */
}

.step-btn {
	background-color: #bad4f2 !important;
	white-space:nowrap;
	min-width: 100px;
}

.header-btn {
	background-color: #b4bac2 !important;
	color: white !important;
}

.min-content-width {
	width: min-content;
}

.alert {
	margin-bottom: 0 !important;
	padding: .375rem .75rem !important;
}

.form-row {
    margin: 0 !important;
}

</style>
